import type { Plan } from '../../../types/api'
import type { PaymentProvider, StoreProduct } from '../../../payments/types'
import { formatDuration } from '../../../lib/pricing'

function programDuration(days: number | null | undefined) {
  if (!days) return ''
  if (days % 7 !== 0) return formatDuration(days)
  const weeks = days / 7
  const plural = new Intl.PluralRules('ru').select(weeks)
  return `${weeks} ${plural === 'one' ? 'неделя' : plural === 'few' ? 'недели' : 'недель'}`
}

export function breakUpPlan(plan: Plan, provider: PaymentProvider, product?: StoreProduct) {
  const renewal = plan.recurring ? 'автопродление' : 'разовый платёж'
  const terms = [formatDuration(plan.duration_days), renewal].filter(Boolean).join(' · ')
  const duration = programDuration(plan.duration_days)
  const benefits = plan.id === 'week'
    ? ['Попробовать неделю все функции', terms, 'Безлимитные сессии']
    : plan.id === 'month'
      ? ['Всё для системной работы', 'Инсайты и динамика', 'Безлимитные сессии']
      : plan.id === 'program'
        ? [`Полная программа${duration ? ` — ${duration}` : ''}`, 'Путь восстановления по стадиям', 'Безлимитные сессии']
        : ['Доступ к функциям приложения', terms]
  const unavailable = provider === 'rustore' ? !product : plan.price == null
  return {
    id: plan.id,
    name: provider === 'rustore' ? product?.title ?? 'Тариф недоступен' : plan.name,
    price: provider === 'rustore'
      ? product?.formattedPrice ?? 'Недоступно'
      : plan.price == null ? 'Недоступно' : `${new Intl.NumberFormat('ru-RU').format(plan.price)} ₽`,
    featured: Boolean(plan.featured),
    recurring: Boolean(plan.recurring),
    unavailable,
    terms,
    benefits,
  }
}

export type BreakUpPlan = ReturnType<typeof breakUpPlan>
